module.exports = __webpack_public_path__ + "static/media/pc_icon_import.7195217e.svg";